import type { InspectionFormState, InspectionFormAction } from "../useInspectionForm";

interface Props {
  state: InspectionFormState;
  dispatch: React.Dispatch<InspectionFormAction>;
}

const labelCls = "text-xs font-medium text-foreground-500 mb-1 block";
const inputCls = "w-full bg-white border border-background-200/70 rounded-lg px-3 py-2 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors";

export default function StepResponsabilidade({ state, dispatch }: Props) {
  return (
    <div className="space-y-5">
      <div className="bg-white rounded-xl border border-background-200/70 p-4 space-y-4">
        <h4 className="text-sm font-semibold text-foreground-800 flex items-center gap-2">
          <i className="ri-user-star-line text-primary-500"></i>
          Responsabilidade Técnica
        </h4>

        <div>
          <label className={labelCls}>Nome do inspetor / responsável técnico</label>
          <input
            type="text"
            value={state.inspectorName}
            onChange={(e) => dispatch({ type: "SET_FIELD", field: "inspectorName", value: e.target.value })}
            placeholder="Nome completo..."
            className={inputCls}
          />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className={labelCls}>Conselho profissional</label>
            <input
              type="text"
              value={state.professionalCouncil}
              onChange={(e) => dispatch({ type: "SET_FIELD", field: "professionalCouncil", value: e.target.value })}
              placeholder="Ex.: CREA, CRBio..."
              className={inputCls}
            />
          </div>
          <div>
            <label className={labelCls}>Registro profissional</label>
            <input
              type="text"
              value={state.professionalRegistration}
              onChange={(e) =>
                dispatch({ type: "SET_FIELD", field: "professionalRegistration", value: e.target.value })
              }
              placeholder="Número do registro..."
              className={inputCls}
            />
          </div>
        </div>

        <div className="p-3 bg-primary-50/40 rounded-lg border border-primary-200/50">
          <p className="text-xs text-primary-700">
            <i className="ri-information-line mr-1"></i>
            Os dados de responsabilidade técnica são necessários para a validação da inspeção.
          </p>
        </div>
      </div>
    </div>
  );
}
